<template>
  <!-- prettier-ignore -->
  <font-awesome-icon
    class="icon"
    :class="{'icon--tooltip': hasTooltip}"
    :icon="iconState"
    v-bind="$attrs"
    @click="preventToggling"
  />
</template>

<script setup>
  import { computed, getCurrentInstance } from 'vue'

  import FontAwesomeIcon from '@shared/config/icons'

  // INIT
  const props = defineProps({
    art: {
      type: [String, Array],
      required: true,
    },

    name: {
      type: String,
      required: true,
    },

    preventInputToggle: {
      type: Boolean,
      default: false,
    },
  })

  // COMPUTED
  const hasTooltip = computed(() => {
    const instance = getCurrentInstance()

    return instance.vnode?.dirs?.length
  })

  const iconState = computed(() => {
    if (Array.isArray(props.art)) {
      return props.art.map(art => `fa-${art}`).join(' ') + ` fa-${props.name}`
    } else {
      return [prefix.value, props.name]
    }
  })

  const prefix = computed(() => {
    switch (props.art) {
      case 'duo':
        return 'fad'

      case 'light':
        return 'fal'

      case 'regular':
        return 'far'

      case 'solid':
        return 'fas'

      case 'thin':
        return 'fat'

      default:
        return console.error('invalid art selected')
    }
  })

  // METHODS
  function preventToggling(event) {
    if (!props.preventInputToggle) return

    event.stopPropagation()
    event.preventDefault()
  }
</script>

<style>
  :root,
  .appearance-positive {
    --pet-icon-c-label: var(--Interaction-States-enabled-default);
  }

  .appearance-extended {
    --pet-icon-c-label: var(--Interaction-States-enabled-extended);
  }
</style>

<style name="mobile" scoped>
  .icon {
    color: inherit;
    transition: color 0.3s ease-in-out;
    font-size: inherit;

    &--tooltip {
      color: var(--pet-icon-c-label);
    }
  }
</style>
